webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(38);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(33);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Work = __webpack_require__(35);
	
	var _Work2 = _interopRequireDefault(_Work);
	
	var _SectionInfo = __webpack_require__(34);
	
	var _SectionInfo2 = _interopRequireDefault(_SectionInfo);
	
	var _avatar = __webpack_require__(12);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Work: _Work2.default,
	    SectionInfo: _SectionInfo2.default
	  },
	  data: function data() {
	    var gameWorkList = [{
	      title: 'KAMELEON',
	      subtitle: '色彩的调和与收集',
	      image: 'game-kameleon.jpg',
	      ratio: 16 / 9,
	      width: 0.85,
	      link: 'http://www.kameleongame.com'
	    }, {
	      title: 'RIPPLE',
	      subtitle: '涟漪的扩散',
	      image: 'game-ripple.png',
	      ratio: 16 / 9,
	      width: 0.85,
	      link: 'http://mida.re/works/game/ripple/'
	    }, {
	      title: 'SNAKE',
	      subtitle: '贪食蛇的简单实现',
	      image: 'game-snake.png',
	      ratio: 16 / 9,
	      width: 0.85,
	      link: 'http://mida.re/works/game/snake/'
	    }];
	
	    var siteWorkList = [{
	      title: '开眼 Eyepetizer',
	      subtitle: '开眼的全部 Web 页面',
	      image: 'site-eyepetizer.jpg',
	      ratio: 3 / 2,
	      width: 0.75,
	      link: 'http://www.wandoujia.com/eyepetizer/'
	    }, {
	      title: '分子互动',
	      subtitle: '综合性公司网站',
	      image: 'site-fenz.png',
	      ratio: 3 / 2,
	      width: 0.75,
	      link: 'http://fen-z.com'
	    }, {
	      title: '人间 JINKAN',
	      subtitle: '滚动渐变',
	      image: 'site-jinkan.jpg',
	      ratio: 3 / 2,
	      width: 0.75,
	      link: 'http://mida.re/works/site/jinkan/'
	    }, {
	      title: '数字媒体艺术',
	      subtitle: '就读专业的介绍',
	      image: 'site-digitalarts.jpg',
	      ratio: 3 / 2,
	      width: 0.75,
	      link: 'http://mida.re/works/site/digitalarts/'
	    }, {
	      title: '温州君顶会所',
	      subtitle: '无滚动条的全屏显示',
	      image: 'site-wzjunding.jpg',
	      ratio: 3 / 2,
	      width: 0.75,
	      link: 'http://mida.re/works/site/wenzhoujunding/'
	    }, {
	      title: '伪鸟居',
	      subtitle: 'CSS 3D 变换',
	      image: 'site-torriacg.jpg',
	      ratio: 3 / 2,
	      width: 0.75,
	      link: 'http://mida.re/works/site/torriacg/'
	    }];
	
	    var designWorkList = [{
	      title: '樱花科技宣传',
	      subtitle: 'AI 矢量绘图',
	      image: 'design-ssbanner.jpg',
	      ratio: 16 / 9,
	      width: 0.85,
	      link: 'image'
	    }, {
	      title: '硬盘图标',
	      subtitle: '简单的图层样式应用',
	      image: 'design-hddicon.jpg',
	      ratio: 1,
	      width: 0.7,
	      link: 'image'
	    }, {
	      title: '天文社海报',
	      subtitle: '中规中矩',
	      image: 'design-astro.jpg',
	      ratio: 720 / 1018,
	      width: 0.7,
	      link: 'image'
	    }];
	
	    var mgWorkList = [{
	      title: 'Equally 字体',
	      subtitle: 'Keynote 动画',
	      image: 'mg-equally.jpg',
	      ratio: 1,
	      width: 0.7,
	      link: 'http://v.youku.com/v_show/id_XNTQ0NTkwOTcy.html'
	    }, {
	      title: '春日祭 LOGO 演示',
	      subtitle: 'Keynote 动画',
	      image: 'mg-kasuga.jpg',
	      ratio: 1,
	      width: 0.7,
	      link: 'http://v.youku.com/v_show/id_XNTQ0NzM4NDA4.html'
	    }, {
	      title: '数媒网站规范',
	      subtitle: 'Keynote 动画',
	      image: 'mg-da.jpg',
	      ratio: 16 / 9,
	      width: 0.8,
	      link: 'http://v.youku.com/v_show/id_XNzMwMjUxODYw.html'
	    }];
	
	    var songList = [{
	      title: '時を刻む唄',
	      subtitle: '「CLANNAD ～AFTER STORY～」OP',
	      link: 'http://www.bilibili.com/video/av4289560/'
	    }, {
	      title: 'When You Wish Upon A Star',
	      subtitle: '「Pinocchio」IN',
	      link: 'http://www.bilibili.com/video/av3829648/'
	    }, {
	      title: 'Someday My Prince Will Come',
	      subtitle: '「Snow White and the Seven Dwarfs」IN',
	      link: 'http://www.bilibili.com/video/av3024599/'
	    }, {
	      title: 'Zzz',
	      subtitle: '「日常」ED',
	      link: 'http://www.bilibili.com/video/av3001231/'
	    }, {
	      title: '少年たちとの別れ ～piano only～',
	      subtitle: '「リトルバスターズ!」OST',
	      link: 'http://www.bilibili.com/video/av2463740/'
	    }, {
	      title: '無題『恋心を奏でる綺想曲』',
	      subtitle: '「リトルバスターズ!」OST',
	      link: 'http://www.bilibili.com/video/av2463736/'
	    }, {
	      title: '薔薇の花びらが舞うように',
	      subtitle: '「氷菓」OST',
	      link: 'http://www.bilibili.com/video/av2214262/'
	    }, {
	      title: 'Old Memory',
	      subtitle: '「ヨスガノソラ」OST',
	      link: 'http://www.bilibili.com/video/av2163207/'
	    }, {
	      title: 'ソリテュード',
	      subtitle: '「甘城ブリリアントパーク」OST',
	      link: 'http://www.bilibili.com/video/av2042592/'
	    }, {
	      title: '相合傘',
	      subtitle: '「月刊少女野崎くん」OST',
	      link: 'http://www.bilibili.com/video/av1585251/'
	    }, {
	      title: 'POWDER SNOW',
	      subtitle: '「WHITE ALBUM」IN',
	      link: 'http://www.bilibili.com/video/av1522352/'
	    }, {
	      title: 'えきぞちっく・といぼっくす',
	      subtitle: '「リトルバスターズ!」OST',
	      link: 'http://www.bilibili.com/video/av1500083/'
	    }, {
	      title: '降り続く雨の街で',
	      subtitle: '「リトルバスターズ!」OST',
	      link: 'http://www.bilibili.com/video/av926721/'
	    }, {
	      title: 'WHITE ALBUM',
	      subtitle: '「WHITE ALBUM 2」EP1·ED',
	      link: 'http://www.bilibili.com/video/av922102/'
	    }, {
	      title: '「戦场ヶ原、荡れ」',
	      subtitle: '「化物語」OST',
	      link: 'http://www.bilibili.com/video/av922045/'
	    }, {
	      title: '见果てぬ梦',
	      subtitle: '「WHITE ALBUM 2」OST',
	      link: 'http://www.bilibili.com/video/av921656/'
	    }];
	
	    var contactList = [{
	      title: 'midare#utakana.de',
	      subtitle: 'Email & QQ, (#)=>@'
	    }, {
	      title: 'http://midare.utakana.de',
	      subtitle: '博客「即兴之歌」',
	      link: 'http://midare.utakana.de'
	    }, {
	      title: 'http://zhihu.com/people/midare',
	      subtitle: '知乎',
	      link: 'http://zhihu.com/people/midare'
	    }];
	
	    _lodash2.default.each([gameWorkList, siteWorkList, designWorkList, mgWorkList], function (workList) {
	      _lodash2.default.each(workList, function (work) {
	        work.image = __webpack_require__(40)("./" + work.image);
	
	        if (work.link === 'image') {
	          work.link = work.image;
	        }
	      });
	    });
	
	
	    return {
	      avatar: _avatar2.default,
	      gameWorkList: gameWorkList,
	      siteWorkList: siteWorkList,
	      designWorkList: designWorkList,
	      mgWorkList: mgWorkList,
	      songList: songList,
	      contactList: contactList,
	      containerWidth: window.innerWidth,
	      copyrightWording: '©' + new Date().getFullYear() + ' midare. Some rights reserved.'
	    };
	  },
	
	  computed: {
	    workContainerLargeStyle: function workContainerLargeStyle() {
	      if (this.containerWidth < 768) {
	        return {
	          height: this.containerWidth * 1.1 + 'px'
	        };
	      }
	
	      return {
	        height: this.containerWidth * 0.75 + 'px'
	      };
	    },
	    workContainerMediumStyle: function workContainerMediumStyle() {
	      if (this.containerWidth < 768) {
	        return {
	          height: this.containerWidth * 1.1 + 'px'
	        };
	      }
	
	      return {
	        height: this.containerWidth / 2 * 0.8 + 'px'
	      };
	    },
	    workContainerSmallStyle: function workContainerSmallStyle() {
	      if (this.containerWidth < 768) {
	        return {
	          height: this.containerWidth * 1.1 + 'px'
	        };
	      }
	
	      return {
	        height: this.containerWidth / 3 * 1.3 + 'px'
	      };
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.containerWidth = document.querySelector('.container').offsetWidth;
	
	    window.onresize = function () {
	      _this.containerWidth = document.querySelector('.container').offsetWidth;
	    };
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'subtitle'],
	  data: function data() {
	    return {};
	  },
	
	  computed: {}
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WorkFrame = __webpack_require__(36);
	
	var _WorkFrame2 = _interopRequireDefault(_WorkFrame);
	
	var _WorkInfo = __webpack_require__(37);
	
	var _WorkInfo2 = _interopRequireDefault(_WorkInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    WorkFrame: _WorkFrame2.default,
	    WorkInfo: _WorkInfo2.default
	  },
	  props: ['image', 'title', 'subtitle', 'ratio', 'width', 'link'],
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    workStyle: function workStyle() {
	      if (this.width < 1) {
	        return {
	          width: this.width * 100 + '%'
	        };
	      }
	
	      return {
	        width: this.width + 'px'
	      };
	    },
	    workInfoContainerStyle: function workInfoContainerStyle() {
	      if (this.width < 1) {
	        return {
	          textAlign: this.infoAlign || 'right'
	        };
	      }
	
	      return {
	        textAlign: this.infoAlign || 'right'
	      };
	    }
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['image', 'ratio', 'link'],
	  data: function data() {
	    return {
	      isHovered: false
	    };
	  },
	
	  computed: {
	    workFrameStyle: function workFrameStyle() {
	      if (this.width < 1) {
	        return {
	          height: this.width / this.ratio * 100 + '%'
	        };
	      }
	
	      return {
	        height: this.width / this.ratio + 'px'
	      };
	    },
	    imageStyle: function imageStyle() {
	      return {
	        backgroundImage: 'url(' + this.image + ')',
	        paddingTop: 100 / this.ratio + '%'
	      };
	    }
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'subtitle'],
	  data: function data() {
	    return {};
	  },
	
	  computed: {}
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */,
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/avatar.d69e439.jpg";

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/design-astro.784001a.jpg";

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/design-hddicon.1ec81d6.jpg";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/design-ssbanner.7205278.jpg";

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/game-kameleon.1b34e49.jpg";

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/game-ripple.577c562.png";

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/game-snake.599a7d2.png";

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mg-da.98f974b.jpg";

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mg-equally.4cf5bf8.jpg";

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mg-kasuga.5bc04b9.jpg";

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/site-digitalarts.991d43a.jpg";

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/site-eyepetizer.6b70a06.jpg";

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/site-fenz.a476393.png";

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/site-jinkan.fc9f772.jpg";

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/site-torriacg.9b4c722.jpg";

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/site-wzjunding.ed61dfa.jpg";

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = " <div id=app> <div class=\"section section-avatar\"> <work id=avatar :image=avatar title=乱序 subtitle=热爱钢琴的伪宅 :ratio=1 :width=225></work> </div> <div class=\"section section-recommand\"> <section-info title=游戏 subtitle=Game></section-info> <div class=container> <div class=\"work-container work-container-large\" v-for=\"work in gameWorkList\" :style=workContainerLargeStyle> <work :title=work.title :subtitle=work.subtitle :image=work.image :ratio=work.ratio :width=work.width :link=work.link></work> </div> </div> </div> <div class=section> <section-info title=站点 subtitle=\"Web site\"></section-info> <div class=container> <div class=\"work-container work-container-medium\" v-for=\"work in siteWorkList\" :style=workContainerMediumStyle> <work :title=work.title :subtitle=work.subtitle :image=work.image :ratio=work.ratio :width=work.width :link=work.link></work> </div> </div> </div> <div class=section> <section-info title=设计 subtitle=Design></section-info> <div class=container> <div class=\"work-container work-container-small\" v-for=\"work in designWorkList\" :style=workContainerSmallStyle> <work :title=work.title :subtitle=work.subtitle :image=work.image :ratio=work.ratio :width=work.width :link=work.link></work> </div> </div> </div> <div class=section> <section-info title=图形动画 subtitle=\"Motion Graphic\"></section-info> <div class=container> <div class=\"work-container work-container-small\" v-for=\"work in mgWorkList\" :style=workContainerSmallStyle> <work :title=work.title :subtitle=work.subtitle :image=work.image :ratio=work.ratio :width=work.width :link=work.link></work> </div> </div> </div> <div class=section> <section-info title=钢琴演奏 subtitle=\"Piano Playing\"></section-info> <div class=container> <div class=paper> <ul class=song-list> <li class=song v-for=\"song in songList\"> <h1><a :href=song.link target=_blank>{{ song.title }}</a></h1> <p>{{ song.subtitle }}</p> </li> </ul> </div> </div> </div> <div class=section> <section-info title=社交与联系 subtitle=\"Social & Contacts\"></section-info> <div class=container> <div class=paper> <ul class=contact-list> <li class=contact v-for=\"contact in contactList\"> <h1 v-if=contact.link><a :href=contact.link target=_blank>{{ contact.title }}</a></h1> <h1 v-if=!contact.link>{{ contact.title }}</h1> <p>{{ contact.subtitle }}</p> </li> </ul> </div> </div> </div> <div class=\"section section-copyright\"> <p>{{ copyrightWording }}</p> </div> </div> ";

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = " <div class=section-info _v-038c035c=\"\"> <h1 _v-038c035c=\"\">{{ title }}</h1> <p _v-038c035c=\"\">{{ subtitle }}</p> </div> ";

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = " <div class=work :style=workStyle _v-2f7699fc=\"\"> <work-frame :image=image :ratio=ratio :width=width :link=link _v-2f7699fc=\"\"></work-frame> <div class=work-info-container :style=workInfoContainerStyle _v-2f7699fc=\"\"> <work-info :title=title :subtitle=subtitle _v-2f7699fc=\"\"></work-info> </div> </div> ";

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = " <div class=work-info _v-35682fd0=\"\"> <h1 _v-35682fd0=\"\">{{ title }}</h1> <p _v-35682fd0=\"\">{{ subtitle }}</p> </div> ";

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = " <div class=work-frame :style=workFrameStyle _v-5152af3b=\"\"> <div class=image-container _v-5152af3b=\"\"> <a v-if=link :href=link target=_blank _v-5152af3b=\"\"> <div class=image :style=imageStyle _v-5152af3b=\"\"></div> </a> <div v-if=!link class=image :style=imageStyle _v-5152af3b=\"\"></div> </div> </div> ";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(6)
	__vue_script__ = __webpack_require__(1)
	__vue_template__ = __webpack_require__(28)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(7)
	__vue_script__ = __webpack_require__(2)
	__vue_template__ = __webpack_require__(29)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(8)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(30)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(10)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(32)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(9)
	__vue_script__ = __webpack_require__(5)
	__vue_template__ = __webpack_require__(31)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 38 */,
/* 39 */,
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./design-astro.jpg": 13,
		"./design-hddicon.jpg": 14,
		"./design-ssbanner.jpg": 15,
		"./game-kameleon.jpg": 16,
		"./game-ripple.png": 17,
		"./game-snake.png": 18,
		"./mg-da.jpg": 19,
		"./mg-equally.jpg": 20,
		"./mg-kasuga.jpg": 21,
		"./site-digitalarts.jpg": 22,
		"./site-eyepetizer.jpg": 23,
		"./site-fenz.png": 24,
		"./site-jinkan.jpg": 25,
		"./site-torriacg.jpg": 26,
		"./site-wzjunding.jpg": 27
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 40;


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.88f28c2794202dcbb0bc.js
 **/